export default {
	inserted (el: HTMLElement, binding: any) {
		el.focus();
	},
};
